// GENERATED CONTENTS. DO NOT EDIT!
export enum Action {
	UserView = 'user_view',
	UserViewFull = 'user_view_full',
	UserList = 'user_list',
	UserExport = 'user_export',
	UserViewBillingAddress = 'user_view_billing_address',
	UserViewBillingContact = 'user_view_billing_contact',
	UserViewLoginMethod = 'user_view_login_method',
	UserCreate = 'user_create',
	UserUpdate = 'user_update',
	UserUpdateBillingContact = 'user_update_billing_contact',
	UserRemove = 'user_remove',
	UserRestore = 'user_restore',
	UserAddToGroup = 'user_add_to_group',
	UserInviteToGroup = 'user_invite_to_group',
	UserSendAccountInvite = 'user_send_account_invite',
	UserReceiveFormInvite = 'user_receive_form_invite',
	UserCreateInvoice = 'user_create_invoice',
	UserCreateChat = 'user_create_chat',
	UserCreateUserLog = 'user_create_user_log',
	UserCreateUserProduct = 'user_create_user_product',
	UserCreateUserGoal = 'user_create_user_goal',
	UserCreateUserGroupPerformanceReview = 'user_create_user_group_performance_review',
	UserCreateUserRating = 'user_create_user_rating',
	UserCreateAccountRelation = 'user_create_account_relation',
	UserListGroups = 'user_list_groups',
	UserListAssessments = 'user_list_assessments',
	UserListEvents = 'user_list_events',
	UserListGoals = 'user_list_goals',
	UserListOrders = 'user_list_orders',
	UserListRelationships = 'user_list_relationships',
	UserListNotes = 'user_list_notes',
	UserListPerformanceReview = 'user_list_performance_review',
	UserListProducts = 'user_list_products',
	UserListAttendanceStats = 'user_list_attendance_stats',
	UserListAttendance = 'user_list_attendance',
	UserListFormSubmissions = 'user_list_form_submissions',
	UserListSubscriptions = 'user_list_subscriptions',
	UserListOwnSubscriptions = 'user_list_own_subscriptions',
	UserListVideos = 'user_list_videos',
	UserListPhysicalStrainStats = 'user_list_physical_strain_stats',
	UserListPlayerProfileGameStats = 'user_list_player_profile_game_stats',
	UserListUserLogs = 'user_list_user_logs',
	UserListPaymentMethods = 'user_list_payment_methods',
	UserListActivePaymentMethods = 'user_list_active_payment_methods',
	UserSwapRelation = 'user_swap_relation',
	UserShowMinutesPlayed = 'user_show_minutes_played',
	UserShowPaymentSource = 'user_show_payment_source',
	UserMerge = 'user_merge',
	UserAddToEvent = 'user_add_to_event',
	UserListUserActivities = 'user_list_user_activities',
	UserListWingfieldConnections = 'user_list_wingfield_connections',
	UserCreateWingfieldConnection = 'user_create_wingfield_connection',
	UserRemoveWingfieldConnection = 'user_remove_wingfield_connection',
	UserListMonitoredChats = 'user_list_monitored_chats',
	UserCreateUserActivity = 'user_create_user_activity',
	UserListExercises = 'user_list_exercises',
	UserListTaggedVideos = 'user_list_tagged_videos',
	UserListVideosFromWingfield = 'user_list_videos_from_wingfield',
	UserListTrainingSessions = 'user_list_training_sessions',
	UserPaymentMethodArchive = 'user_payment_method_archive',
	SubscriptionSetPaymentMethod = 'subscription_change_payment_method',
	SubscriptionView = 'subscription_view',
	SubscriptionUpdate = 'subscription_update',
	SubscriptionCancel = 'subscription_cancel',
	SubscriptionViewCustomerUser = 'subscription_view_customer_user',
	SubscriptionReactivate = 'subscription_reactivate',
	SubscriptionUpdateProductRecipient = 'subscription_update_product_recipient',
	GroupView = 'group_view',
	GroupUpdate = 'group_update',
	GroupClearInviteCode = 'group_clear_invite_code',
	GroupRemove = 'group_remove',
	GroupRemoveUser = 'group_remove_user',
	GroupAddUser = 'group_add_user',
	GroupBanUser = 'group_ban_user',
	GroupListCreditNotes = 'group_list_credit_notes',
	GroupCreatePerformanceReview = 'group_create_performance_review',
	GroupListLibraryTags = 'group_list_library_tags',
	GroupManageLibraryTags = 'group_manage_library_tags',
	GroupViewLibraryTagsSettings = 'group_view_library_tags_settings',
	GroupShareTrainingCollectionTo = 'group_share_training_collection_to',
	GroupShareTrainingSessionTo = 'group_share_training_session_to',
	GroupShareExerciseTo = 'group_share_exercise_to',
	GroupCreateUserLog = 'group_create_user_log',
	GroupCreateUserRating = 'group_create_user_rating',
	GroupShowUsers = 'group_show_users',
	GroupListOpponents = 'group_list_opponents',
	GroupCreateOpponent = 'group_create_opponent',
	GroupListCompetitions = 'group_list_competitions',
	GroupCreateCompetition = 'group_create_competition',
	GroupListTournaments = 'group_list_tournaments',
	GroupCreateTournament = 'group_create_tournament',
	GroupShowRatingResults = 'group_show_rating_results',
	GroupCreateLineup = 'group_create_lineup',
	GroupListLineups = 'group_list_lineups',
	GroupListFormations = 'group_list_formations',
	GroupCreateFormation = 'group_create_formation',
	GroupRemoveFormation = 'group_remove_formation',
	GroupCreateEvent = 'group_create_event',
	GroupCreateEventSeries = 'group_create_event_series',
	GroupViewGameStatistics = 'group_view_game_statistics',
	GroupViewGameHistory = 'group_view_game_history',
	GroupViewTrainingStatistics = 'group_view_training_statistics',
	GroupViewSportsStatistics = 'group_view_sports_statistics',
	GroupViewActivitySummaryStatistics = 'group_view_activity_summary_statistics',
	GroupViewPlayerStatistics = 'group_view_player_statistics',
	GroupViewFormSubmissionTab = 'group_view_form_submission_tab',
	GroupListLastGames = 'group_list_last_games',
	GroupViewGamesNavigation = 'group_view_games_navigation',
	GroupShowMinutesPlayed = 'group_show_minutes_played',
	GroupListEvents = 'group_list_events',
	GroupExportEvents = 'group_export_events',
	GroupEventReport = 'group_event_report',
	GroupListChildGroups = 'group_list_sub_groups',
	GroupViewHierarchy = 'group_view_hierarchy',
	GroupUpdateSortOrder = 'group_update_sort_order',
	GroupShowParentGroup = 'group_show_parent_group',
	GroupListGroupPosts = 'group_list_posts',
	GroupCreateGroupPost = 'group_create_group_post',
	GroupSetPublishingOptionsOnGroupPost = 'group_set_publishing_options_on_group_post',
	GroupShowBannedMembers = 'group_show_banned_members',
	GroupShowPendingMembers = 'group_show_pending_members',
	GroupExportMembers = 'group_export_members',
	GroupShowMemberActivities = 'group_show_member_activities',
	GroupShowUserGroupPerformanceReviews = 'group_show_user_group_performance_reviews',
	GroupUpdatePerformanceReviewTemplate = 'group_update_performance_review_template',
	GroupInviteUsers = 'group_invite_users',
	GroupListAccountInvites = 'group_list_account_invites',
	GroupUpdateUser = 'group_update_user',
	GroupShowUsersRecursively = 'group_show_users_recursively',
	GroupShowLegalGuardiansForMembers = 'group_show_legal_guardians_for_members',
	GroupShowUserProducts = 'group_show_user_products',
	GroupUpdateCurrency = 'group_update_currency',
	GroupListCurrencies = 'group_list_currencies',
	GroupUpdateServiceFee = 'group_update_service_fee',
	GroupShowUserProductsForMembers = 'group_show_user_products_for_members',
	GroupShowTrainingSessionStatistics = 'group_show_training_session_statistics',
	GroupConnectWithFogis = 'group_connect_with_fogis',
	GroupConnectWithSweHockey = 'group_connect_with_swehockey',
	GroupConnectWithIbis = 'group_connect_with_ibis',
	GroupConnectWithProfixio = 'group_connect_with_profixio',
	GroupRemoveBookings = 'group_remove_bookings',
	GroupListBookings = 'group_list_bookings',
	GroupListBookingGroups = 'group_list_booking_groups',
	GroupListForms = 'group_list_forms',
	GroupCreateForm = 'group_create_form',
	GroupListFormPayments = 'group_list_form_payments',
	GroupListFormCategories = 'group_list_form_categories',
	GroupListDiscounts = 'group_list_discounts',
	GroupListUserFields = 'group_list_user_fields',
	GroupCreateDiscount = 'group_create_discount',
	GroupListProducts = 'group_list_products',
	GroupListResources = 'group_list_resources',
	GroupCreateResource = 'group_create_resource',
	GroupListResourceLocations = 'group_list_resource_locations',
	GroupListResourceCategories = 'group_list_resource_categories',
	GroupListSchedules = 'group_list_schedules',
	GroupCreateSchedule = 'group_create_schedule',
	GroupListGroupLinks = 'group_list_group_links',
	GroupUpdateGroupLinks = 'group_update_group_links',
	GroupListProductCategories = 'group_list_product_categories',
	GroupListTaxRates = 'group_list_tax_rates',
	GroupCreateTaxRate = 'group_create_tax_rate',
	GroupListSubscriptions = 'group_list_subscriptions',
	GroupExportSubscriptions = 'group_export_subscriptions',
	GroupListTrainingCollections = 'group_list_training_collections',
	GroupListSharedTrainingCollections = 'group_list_shared_training_collections',
	GroupListSharedTrainingSessions = 'group_list_shared_training_sessions',
	GroupListSharedExercises = 'group_list_shared_exercises',
	GroupListVideos = 'group_list_videos',
	GroupListVideoCollections = 'group_list_video_collections',
	GroupCreateVideo = 'group_create_video',
	GroupCreateVideoCollection = 'group_create_video_collection',
	GroupCreateVideoPlaylist = 'group_create_video_playlist',
	GroupCreateExercise = 'group_create_exercise',
	GroupCreateTrainingSession = 'group_create_training_session',
	GroupCreateTrainingCollection = 'group_create_training_collection',
	GroupCreateSelfRating = 'group_create_self_rating',
	GroupCreateUserActivity = 'group_create_user_activity',
	OrganizationCreateUser = 'organization_create_user',
	OrganizationCreateProduct = 'organization_create_product',
	OrganizationListAllWingfieldUsers = 'organization_list_all_wingfield_users',
	OrganizationListOrders = 'organization_list_orders',
	OrganizationListForms = 'organization_list_forms',
	OrganizationListFormInvitations = 'organization_list_form_invitations',
	OrganizationExportOrders = 'organization_export_orders',
	OrganizationOrderReport = 'organization_order_report',
	OrganizationView = 'organization_view',
	OrganizationUpdateLOKSettings = 'organization_update_lok_settings',
	OrganizationUpdateSvffImports = 'organization_update_svff_imports',
	GroupUpdateSvffImports = 'group_update_svff_imports',
	GroupUpdateFederationImports = 'group_update_federation_imports',
	OrganizationViewPaymentConfig = 'organization_view_payment_config',
	OrganizationViewFritidskortetReport = 'organization_view_fritidskortet_report',
	OrganizationViewAdminOnboarding = 'organization_view_admin_onboarding',
	OrganizationViewAdminOnboardingPaymentsSection = 'organization_view_admin_onboarding_payments_section',
	OrganizationRegisterInvopopSupplier = 'organization_register_invopop_supplier',
	OrganizationInvopopSupplierEligible = 'organization_invopop_supplier_eligible',
	OrganizationViewInvopopSupplierData = 'organization_view_invopop_supplier_data',
	OrganizationViewPaymentsSettings = 'organization_view_payments_settings',
	OrganizationViewWebsiteSettings = 'organization_view_website_settings',
	OrganizationCreateOrder = 'organization_create_order',
	OrganizationListPayouts = 'organization_list_payouts',
	OrganizationListDisputes = 'organization_list_disputes',
	OrganizationExportPayouts = 'organization_export_payouts',
	OrganizationListGroupPosts = 'organization_list_group_posts',
	OrganizationCreatePaymentAccount = 'organization_create_payment_account',
	OrganizationListUsers = 'organization_list_users',
	OrganizationListContacts = 'organization_list_contacts',
	OrganizationManageDuplicates = 'organization_manage_duplicates',
	OrganizationExportUsers = 'organization_export_users',
	OrganizationViewManagementDashboard = 'organization_view_management_dashboard',
	OrganizationViewNetwork = 'organization_view_network',
	OrganizationViewNetworkMembers = 'organization_view_network_members',
	OrganizationViewNetworkPayments = 'organization_view_network_payments',
	OrganizationViewNetworkRegistrations = 'organization_view_network_registrations',
	OrganizationCreateNetworkPost = 'organization_create_network_post',
	OrganizationViewPaymentData = 'organization_view_payment_data',
	OrganizationUpdateSplashScreen = 'organization_update_splash_screen',
	OrganizationListIdentityProviders = 'organization_list_identity_providers',
	OrganizationCreateChat = 'organization_create_chat',
	OrganizationListRoles = 'organization_list_roles',
	OrganizationCreateRole = 'organization_create_role',
	OrganizationDisplayAds = 'organization_display_ads',
	GroupUseAIAssistant = 'group_use_ai_assistant',
	GroupUseAIPostHelper = 'group_use_ai_post_helper',
	GroupViewAIConversation = 'group_view_ai_conversation',
	OrganizationAICSVImport = 'organization_ai_csv_import',
	GroupAIEventImport = 'group_ai_event_import',
	OrganizationAIUserImport = 'organization_ai_user_import',
	GroupAISessionCreator = 'group_ai_session_creator',
	OrganizationCreateExercise = 'organization_create_exercise',
	OrganizationCreateTrainingSession = 'organization_create_training_session',
	OrganizationCreateTrainingCollection = 'organization_create_training_collection',
	OrganizationWalletEligible = 'organization_wallet_eligible',
	OrganizationWalletManage = 'organization_wallet_manage',
	OrganizationWalletConnected = 'organization_wallet_connected',
	OrganizationListUserFieldCategories = 'organization_list_user_field_categories',
	OrganizationManageUserFields = 'organization_manage_user_fields',
	PayoutView = 'payout_view',
	PayoutExportPayoutRows = 'payout_export_payout_rows',
	OrderView = 'order_view',
	OrderMarkAsPaid = 'order_mark_as_paid',
	OrderMarkAsUncollectible = 'order_mark_as_uncollectible',
	OrderMarkAsVoid = 'order_mark_as_void',
	OrderSendReminder = 'order_send_reminder',
	OrderSendReceipt = 'order_send_receipt',
	OrderRefund = 'order_refund',
	OrderRefundFritidskortet = 'order_refund_fritidskortet',
	OrderRefundCharge = 'order_refund_charge',
	OrderRemove = 'order_remove',
	OrderDuplicate = 'order_duplicate',
	OrderInitiatePayment = 'order_initiate_payment',
	OrderRegisterInvopopInvoice = 'order_register_invopop_invoice',
	OrderUpdateProductRecipient = 'order_update_product_recipient',
	ExerciseDuplicate = 'exercise_duplicate',
	ExerciseView = 'exercise_view',
	ExerciseCreate = 'exercise_create',
	ExerciseUpdate = 'exercise_update',
	ExerciseRemove = 'exercise_remove',
	ExerciseShare = 'exercise_share',
	ExerciseGroupShare = 'exercise_group_share',
	AttachmentDuplicate = 'attachment_duplicate',
	AttachmentAttach = 'attachment_attach',
	UserFieldCategoryCreate = 'user_field_category_create',
	UserFieldCategoryUpdate = 'user_field_category_update',
	UserFieldCategoryRemove = 'user_field_category_remove',
	OrganizationLinkCreate = 'organization_link_create',
	OrganizationLinkRemove = 'organization_link_remove',
	UserExercisePinCreate = 'user_exercise_pin_create',
	UserExercisePinRemove = 'user_exercise_pin_remove',
	UserTrainingSessionPinCreate = 'user_training_session_pin_create',
	UserTrainingSessionPinRemove = 'user_training_session_pin_remove',
	UserTrainingCollectionPinCreate = 'user_training_collection_pin_create',
	UserTrainingCollectionPinRemove = 'user_training_collection_pin_remove',
	TrainingCollectionView = 'training_collection_view',
	TrainingCollectionShare = 'training_collection_share',
	TrainingCollectionGroupShare = 'training_collection_group_share',
	TrainingCollectionRemove = 'training_collection_remove',
	TrainingCollectionUpdate = 'training_collection_update',
	TrainingCollectionContribute = 'training_collection_contribute',
	TrainingCollectionCreate = 'training_collection_create',
	IdentityProviderCreate = 'identity_provider_create',
	IdentityProviderUpdate = 'identity_provider_update',
	IdentityProviderDuplicate = 'identity_provider_duplicate',
	IdentityProviderView = 'identity_provider_view',
	IdentityProviderRemove = 'identity_provider_remove',
	IdentityProviderUpdateSSO = 'identity_provider_update_sso',
	IdentityProviderUpdateSync = 'identity_provider_update_sync',
	IdentityProviderPortalSSO = 'identity_provider_portal_sso',
	IdentityProviderPortalSync = 'identity_provider_portal_sync',
	IdentityProviderMapping = 'identity_provider_mapping',
	UserRatingView = 'user_rating_view',
	UserRatingViewScores = 'user_rating_view_scores',
	UserRatingTogglePrimary = 'user_rating_toggle_primary',
	UserRatingCreate = 'user_rating_create',
	UserRatingUpdate = 'user_rating_update',
	UserRatingRemove = 'user_rating_remove',
	UserProductView = 'user_product_view',
	UserProductCreate = 'user_product_create',
	UserProductUpdate = 'user_product_update',
	UserProductRemove = 'user_product_remove',
	UserProductViewOrder = 'user_product_view_order',
	UserProductGenerateQRToken = 'user_product_generate_qr_token',
	GroupPaymentConfigOnboard = 'group_payment_config_onboard',
	GroupPaymentConfigReporting = 'group_payment_config_reporting',
	GroupPaymentConfigUpdateWebsite = 'group_payment_config_update_website',
	GroupPaymentConfigUpdateSplitConfiguration = 'group_payment_config_update_split_configuration',
	GroupPaymentConfigDisputes = 'group_payment_config_disputes',
	GroupPaymentConfigActivateAmex = 'group_payment_config_activate_amex',
	GroupPaymentConfigActivateSwish = 'group_payment_config_activate_swish',
	GroupPaymentConfigActivateMBWay = 'group_payment_config_activate_mbway',
	GroupPaymentConfigActivateApplePay = 'group_payment_config_activate_apple_pay',
	GroupPaymentConfigActivateGooglePay = 'group_payment_config_activate_google_pay',
	GroupPaymentConfigActivateACH = 'group_payment_config_activate_ach',
	GroupPaymentConfigActivateTrustly = 'group_payment_config_activate_trustly',
	GroupPaymentConfigActivatePayByBank = 'group_payment_config_activate_pay_by_bank',
	UserGoalUpdate = 'user_goal_update',
	UserGoalRemove = 'user_goal_remove',
	UserGroupPerformanceReviewUpdate = 'user_group_performance_review_update',
	UserGroupPerformanceReviewRemove = 'user_group_performance_review_remove',
	UserGroupPerformanceReviewView = 'user_group_performance_review_view',
	UserGroupPerformanceReviewAddAttachment = 'user_group_performance_review_add_attachment',
	UserGroupPerformanceReviewAttachmentRemove = 'user_group_performance_review_attachment_remove',
	UserGroupView = 'user_group_view',
	UserGroupList = 'user_group_list',
	UserGroupViewRoleCapabilities = 'user_group_view_role_capabilities',
	UserGroupUpdateRoleCapabilityOverrides = 'user_group_update_role_capability_overrides',
	UserGroupAssignOwnerRole = 'user_group_assign_owner_role',
	UserLogView = 'user_log_view',
	UserLogCreate = 'user_log_create',
	UserLogUpdate = 'user_log_update',
	UserLogRemove = 'user_log_remove',
	UserLogAddAttachment = 'user_log_add_attachment',
	UserLogAttachmentRemove = 'user_log_attachment_remove',
	AccountCreateRelation = 'account_create_relation',
	AccountSwapRelation = 'account_swap_relation',
	AccountListEvents = 'account_list_events',
	AccountUpdate = 'account_update',
	AccountRemove = 'account_remove',
	AccountHandleConsent = 'account_handle_consent',
	AccountInviteAsWard = 'account_invite_as_ward',
	AccountListRelations = 'account_list_relations',
	AccountView = 'account_view',
	AccountListExercises = 'account_list_exercises',
	AccountListVideos = 'account_list_videos',
	AccountRelationCreate = 'account_relation_create',
	AccountRelationSwap = 'account_relation_swap',
	AccountRelationApprove = 'account_relation_approve',
	AccountRelationRemove = 'account_relation_remove',
	GameView = 'game_view',
	GameCreate = 'game_create',
	GameUpdate = 'game_update',
	GameListUsers = 'game_list_users',
	GameViewTimePlayed = 'game_view_time_played',
	GameGenerateTimePlayed = 'game_generate_time_played',
	GameUpsertTimePlayed = 'game_upsert_time_played',
	GameViewLineup = 'game_view_lineup',
	GameCreateLineup = 'game_create_lineup',
	GameCreateReport = 'game_create_report',
	GameListVideos = 'game_list_videos',
	GameAddVideo = 'game_add_video',
	GameRemoveVideo = 'game_remove_video',
	GameReportUpdate = 'game_report_update',
	GameReportRemove = 'game_report_remove',
	GameReportView = 'game_report_view',
	EventListEventUsers = 'event_list_users',
	EventUpdate = 'event_update',
	EventView = 'event_view',
	EventRemove = 'event_remove',
	EventSyncRfapi = 'event_sync_rfapi',
	EventAddComment = 'event_add_comment',
	EventViewPhysicalStrain = 'event_view_physical_strain',
	EventCreateTrainingSession = 'event_create_training_session',
	EventViewSessionGroups = 'event_view_session_groups',
	EventUserUpdate = 'event_user_update',
	EventUserView = 'event_user_view',
	EventUserViewComment = 'event_user_view_comment',
	EventUserViewUser = 'event_user_view_user',
	EventUserEditUser = 'event_user_edit_user',
	EventSeriesListEventUsers = 'event_series_list_users',
	EventSeriesView = 'event_series_view',
	EventSeriesUpdate = 'event_series_update',
	EventSeriesRemove = 'event_series_remove',
	EventSeriesUserUpdate = 'event_series_user_update',
	EventSeriesUserView = 'event_series_user_view',
	EventCommentUpdate = 'event_comment_update',
	EventCommentRemove = 'event_comment_remove',
	EventViewCarpool = 'event_view_carpool',
	EventAddCarpool = 'event_add_carpool',
	EventCarpoolUpdate = 'event_carpool_update',
	EventCarpoolRemove = 'event_carpool_remove',
	EventCarpoolPassengerAdd = 'event_carpool_passenger_add',
	EventCarpoolPassengerRemove = 'event_carpool_passenger_remove',
	EventCarpoolRequestAdd = 'event_carpool_request_add',
	EventCarpoolRequestRemove = 'event_carpool_request_remove',
	UserFieldValueView = 'user_field_value_view',
	UserFieldView = 'user_field_view',
	UserFieldCreate = 'user_field_create',
	UserFieldUpdate = 'user_field_update',
	UserFieldRemove = 'user_field_remove',
	OpponentView = 'opponent_view',
	OpponentCreate = 'opponent_create',
	OpponentUpdate = 'opponent_update',
	OpponentRemove = 'opponent_remove',
	OpponentPlayerView = 'opponent_player_view',
	OpponentPlayerCreate = 'opponent_player_create',
	OpponentPlayerUpdate = 'opponent_player_update',
	OpponentPlayerRemove = 'opponent_player_remove',
	CompetitionView = 'competition_view',
	CompetitionCreate = 'competition_create',
	CompetitionUpdate = 'competition_update',
	CompetitionRemove = 'competition_remove',
	TournamentView = 'tournament_view',
	TournamentPublicView = 'tournament_public_view',
	TournamentCreate = 'tournament_create',
	TournamentUpdate = 'tournament_update',
	TournamentRemove = 'tournament_remove',
	TournamentDuplicate = 'tournament_duplicate',
	TournamentPublish = 'tournament_publish',
	TournamentUnpublish = 'tournament_unpublish',
	TournamentTeamSetVenue = 'tournament_team_set_venue',
	TournamentTeamRemove = 'tournament_team_remove',
	TournamentGameEdit = 'tournament_game_edit',
	TournamentGameDelete = 'tournament_game_delete',
	TournamentGameAddResult = 'tournament_game_add_result',
	TournamentGameUnschedule = 'tournament_game_unschedule',
	TournamentGameReschedule = 'tournament_game_reschedule',
	ProductCreateUserProduct = 'product_create_user_product',
	ProductCreateProductPrice = 'product_create_product_price',
	ProductCreate = 'product_create',
	ProductView = 'product_view',
	ProductUpdate = 'product_update',
	ProductArchive = 'product_archive',
	ProductPriceView = 'product_price_view',
	ProductPriceUpdate = 'product_price_update',
	ProductPriceArchive = 'product_price_archive',
	ChatCreateMessage = 'chat_create_message',
	ChatUpdate = 'chat_update',
	ChatView = 'chat_view',
	ChatRemove = 'chat_remove',
	ChatAddReaction = 'chat_add_reaction',
	ChatRemoveReaction = 'chat_remove_reaction',
	ChatSendEvent = 'chat_send_event',
	ChatAddPeople = 'chat_add_people',
	ChatPollVote = 'chat_poll_vote',
	ChatCreatePoll = 'chat_create_poll',
	ChatListen = 'chat_listen',
	ChatUserRemove = 'chat_user_remove',
	ChatUserUpdate = 'chat_user_update',
	ChatUserMute = 'chat_user_mute',
	ChatMessageUpdate = 'chat_message_update',
	ChatMessageRemove = 'chat_message_remove',
	FormCreate = 'form_create',
	FormCreateInvite = 'form_create_invite',
	FormUpdateInvite = 'form_update_invite',
	FormDeleteInvite = 'form_delete_invite',
	FormSendInvites = 'form_send_invites',
	FormListInvites = 'form_list_invites',
	FormUpdate = 'form_update',
	FormManageProductPrice = 'form_manage_product_price',
	FormRemove = 'form_remove',
	FormSetStatusOpen = 'form_set_status_open',
	FormChangeCustomFieldTypes = 'form_change_custom_field_types',
	FormChangeTemplate = 'form_change_template',
	FormDuplicate = 'form_duplicate',
	FormView = 'form_view',
	FormPublicView = 'form_public_view',
	FormExport = 'form_export',
	FormListOrders = 'form_list_orders',
	FormSubmit = 'form_submit',
	FormPublicSubmit = 'form_public_submit',
	FormListTeamInvitation = 'form_list_team_invitation',
	FormTeamInvitationManagerShow = 'form_team_invitation_manager_show',
	FormTeamInvitationManagerInvite = 'form_team_invitation_manager_invite',
	FormListSubmissionsPackageManager = 'form_list_submission_package_manager',
	FormPackageIndex = 'form_package_index',
	FormManagePackages = 'form_manage_packages',
	FormManagePackagePayments = 'form_manage_package_payments',
	FormManageEventGroups = 'form_manage_event_groups',
	FormCreateEventGroups = 'form_create_event_groups',
	FormManageFormFields = 'form_manage_form_fields',
	FormFieldIndex = 'form_field_index',
	FormManageFormAgreements = 'form_manage_form_agreements',
	FormCategoryListForms = 'form_category_list_forms',
	FormCategoryCreate = 'form_category_create',
	FormCategoryUpdate = 'form_category_update',
	FormCategoryRemove = 'form_category_remove',
	FormSubmissionCancel = 'form_submission_cancel',
	FormSubmissionView = 'form_submission_view',
	FormSubmissionViewPaymentStatus = 'form_submission_view_payment_status',
	FormSubmissionRejectInvite = 'form_submission_reject_invite',
	FormSubmissionUpdate = 'form_submission_update',
	FormSubmissionRemove = 'form_submission_remove',
	FormSubmissionManagerView = 'form_submission_manager_view',
	FormSubmissionTeamInvitationCreate = 'form_submission_team_invitation_create',
	FormSubmissionTeamInvitationUpdate = 'form_submission_team_invitation_update',
	FormSubmissionTeamInvitationDelete = 'form_submission_team_invitation_delete',
	FormSubmissionTeamInvitationResend = 'form_submission_team_invitation_resend',
	FormSubmissionInviteResolve = 'form_submission_invite_resolve',
	FormSubmissionForUserView = 'form_submission_for_user_view',
	FormSubmissionUserView = 'form_submission_user_view',
	FormSubmissionCreateInvoice = 'form_submission_create_invoice',
	FormSubmissionAssignProduct = 'form_submission_assign_product',
	FormSubmissionAddToGroup = 'form_submission_add_to_group',
	FormSubmissionFormView = 'form_submission_form_view',
	FormSubmissionEmailSubmittedFor = 'form_submission_email_submitted_for',
	FormSubmissionEmailSubmittedBy = 'form_submission_email_submitted_by',
	CreditNoteView = 'credit_note_view',
	CreditNoteRegisterInvopopCreditNote = 'credit_note_register_invopop_credit_note',
	LineupView = 'lineup_view',
	LineupUpdate = 'lineup_update',
	LineupRemove = 'lineup_remove',
	GameVideoCreate = 'game_video_create',
	VideoUpdate = 'video_update',
	VideoAddToGame = 'video_add_to_game',
	VideoView = 'video_view',
	VideoCreate = 'video_create',
	VideoRemove = 'video_remove',
	VideoListUsers = 'video_list_users',
	VideoCreateSequence = 'video_create_sequence',
	VideoSequenceView = 'video_sequence_view',
	VideoSequenceUpdate = 'video_sequence_update',
	VideoSequenceRemove = 'video_sequence_remove',
	VideoSequenceCreateComment = 'video_sequence_create_comment',
	VideoSequenceListUsers = 'video_sequence_list_users',
	VideoSequenceCommentView = 'video_sequence_comment_view',
	VideoSequenceCommentUpdate = 'video_sequence_comment_update',
	VideoSequenceCommentRemove = 'video_sequence_comment_remove',
	SiteView = 'site_view',
	SiteUpdate = 'site_update',
	DiscountView = 'discount_view',
	DiscountUpdate = 'discount_update',
	DiscountRemove = 'discount_remove',
	AccountInviteView = 'account_invite_view',
	AccountInviteClaim = 'account_invite_claim',
	AccountInviteRemove = 'account_invite_remove',
	BookingCreate = 'booking_create',
	BookingUpdate = 'booking_update',
	BookingRemove = 'booking_remove',
	ResourceView = 'resource_view',
	ResourceCreate = 'resource_create',
	ResourceUpdate = 'resource_update',
	ResourceRemove = 'resource_remove',
	ResourceLocationView = 'resource_location_view',
	ResourceLocationCreate = 'resource_location_create',
	ResourceLocationUpdate = 'resource_location_update',
	ResourceLocationRemove = 'resource_location_remove',
	ResourceCategoryView = 'resource_category_view',
	ResourceCategoryCreate = 'resource_category_create',
	ResourceCategoryUpdate = 'resource_category_update',
	ResourceCategoryRemove = 'resource_category_remove',
	ScheduleView = 'schedule_view',
	ScheduleCreate = 'schedule_create',
	ScheduleUpdate = 'schedule_update',
	ScheduleRemove = 'schedule_remove',
	SchedulePublish = 'schedule_publish',
	ScheduleCreateScheduleItem = 'schedule_create_schedule_item',
	ScheduleItemUpdate = 'schedule_item_update',
	ScheduleItemRemove = 'schedule_item_remove',
	ProductCategoryView = 'product_category_view',
	ProductCategoryCreate = 'product_category_create',
	ProductCategoryUpdate = 'product_category_update',
	ProductCategoryRemove = 'product_category_remove',
	BillingGroupList = 'billing_group_list',
	BillingGroupView = 'billing_group_view',
	BillingGroupCreate = 'billing_group_create',
	BillingGroupUpdate = 'billing_group_update',
	BillingGroupRemove = 'billing_group_remove',
	BillingGroupAddMember = 'billing_group_add_member',
	BillingGroupRemoveMember = 'billing_group_remove_member',
	BillingGroupSelfView = 'billing_group_self_view',
	BillingGroupSelfManage = 'billing_group_self_manage',
	BillingGroupSelfCreate = 'billing_group_self_create',
	TaxRateView = 'tax_rate_view',
	TaxRateUpdate = 'tax_rate_update',
	TaxRateRemove = 'tax_rate_remove',
	GroupPostView = 'group_post_view',
	GroupPostCreate = 'group_post_create',
	GroupPostUpdate = 'group_post_update',
	GroupPostRemove = 'group_post_remove',
	GroupPostSetPublishingOptions = 'group_post_set_publishing_options',
	GroupPostShowViews = 'group_post_show_views',
	GroupPostShowLikes = 'group_post_show_likes',
	GroupPostListComments = 'group_post_list_comments',
	GroupPostCreateComment = 'group_post_create_comment',
	GroupPostCommentUpdate = 'group_post_comment_update',
	GroupPostCommentRemove = 'group_post_comment_remove',
	UserActivityView = 'user_activity_view',
	UserActivityUpdate = 'user_activity_update',
	UserActivityRemove = 'user_activity_remove',
	TrainingSessionView = 'training_session_view',
	TrainingSessionCreate = 'training_session_create',
	TrainingSessionUpdate = 'training_session_update',
	TrainingSessionRemove = 'training_session_remove',
	TrainingSessionDuplicate = 'training_session_duplicate',
	TrainingSessionShare = 'training_session_share',
	TrainingSessionGroupShare = 'training_session_group_share',
	VideoCollectionView = 'video_collection_view',
	VideoCollectionCreate = 'video_collection_create',
	VideoCollectionUpdate = 'video_collection_update',
	VideoCollectionRemove = 'video_collection_remove',
	VideoCollectionContribute = 'video_collection_contribute',
	VideoPlaylistView = 'video_playlist_view',
	VideoPlaylistCreate = 'video_playlist_create',
	VideoPlaylistUpdate = 'video_playlist_update',
	VideoPlaylistRemove = 'video_playlist_remove',
	VideoPlaylistAddSequences = 'video_playlist_add_sequences',
	AccountListVideoPlaylists = 'account_list_video_playlists',
	UserListVideoPlaylists = 'user_list_video_playlists',
	GroupListVideoPlaylists = 'group_list_video_playlists',
	RoleView = 'role_view',
	RoleUpdate = 'role_update',
	RoleDelete = 'role_delete',
	RoleDuplicate = 'role_duplicate',
	AIConversationCreate = 'ai_conversation_create',
	AIConversationView = 'ai_conversation_view',
	AIConversationUpdate = 'ai_conversation_update',
	AIConversationUploadFile = 'ai_conversation_upload_file',
	AIMessageCreate = 'ai_message_create',
	AIMessageView = 'ai_message_view',
	AIMessageUpdate = 'ai_message_update',
	AIComponentComplete = 'ai_component_complete',
	AIComponentCancel = 'ai_component_cancel',
	GroupListAgreements = 'group_list_agreements',
	GroupCreateAgreement = 'group_create_agreement',
	AgreementRemove = 'agreement_remove',
	AgreementRestore = 'agreement_restore',
	AgreementView = 'agreement_view',
	AgreementUpdate = 'agreement_update',
	AgreementUpdateContent = 'agreement_update_content',
	GroupListPracticePlans = 'group_list_practice_plans',
	GroupCreatePracticePlan = 'group_create_practice_plan',
	PracticePlanView = 'practice_plan_view',
	PracticePlanUpdate = 'practice_plan_update',
	PracticePlanRemove = 'practice_plan_remove',
	PracticePlanAddGroup = 'practice_plan_add_group',
	PracticePlanDuplicate = 'practice_plan_duplicate',
	PracticePlanManageSchedule = 'practice_plan_manage_schedule',
	PracticePlanGroupView = 'practice_plan_group_view',
	PracticePlanGroupUpdate = 'practice_plan_group_update',
	PracticePlanGroupRemove = 'practice_plan_group_remove',
	PracticePlanGroupManageEvents = 'practice_plan_group_manage_events',
	PracticePlanGroupManageSessionGroups = 'practice_plan_group_manage_session_groups',
	PracticePlanGroupGenerate = 'practice_plan_group_generate',
	PracticePlanGroupRelease = 'practice_plan_group_release',
	AIEventImportSessionRemove = 'ai_event_import_session_remove',
	OrganizationListPapiKeys = 'organization_list_papi_keys',
	OrganizationCreatePapiKey = 'organization_create_papi_key',
	PapiKeyView = 'papi_key_view',
	PapiKeyUpdate = 'papi_key_update',
	PapiKeyRotate = 'papi_key_rotate',
	PapiKeyRevoke = 'papi_key_revoke',
	AIUserImportSessionRemove = 'ai_user_import_session_remove',
	AIUserImportSessionView = 'ai_user_import_session_view',
	OrganizationListIntegrations = 'organization_list_integrations',
	OrganizationListLokSyncRuns = 'organization_list_lok_sync_runs',
	IntegrationConnectionView = 'integration_connection_view',
	IntegrationConnectionCreate = 'integration_connection_create',
	IntegrationConnectionUpdate = 'integration_connection_update',
	IntegrationConnectionDelete = 'integration_connection_delete',
	GroupListEvaluations = 'group_list_evaluations',
	GroupCreateEvaluation = 'group_create_evaluation',
	GroupSendEvaluations = 'group_send_evaluations',
	GroupViewEvaluationSettings = 'group_view_evaluation_settings',
	EvaluationUpdate = 'evaluation_update',
	EvaluationArchive = 'evaluation_archive',
	EvaluationDelete = 'evaluation_delete',
	EvaluationCycleUpdate = 'evaluation_cycle_update',
	EvaluationCyclePause = 'evaluation_cycle_pause',
	EvaluationCycleResume = 'evaluation_cycle_resume',
	EvaluationCycleSkip = 'evaluation_cycle_skip',
	EvaluationCycleStop = 'evaluation_cycle_stop',
	EvaluationCycleOpen = 'evaluation_cycle_open',
	EvaluationRunView = 'evaluation_run_view',
	EvaluationRunPublish = 'evaluation_run_publish',
	EvaluationRunRemind = 'evaluation_run_remind',
	EvaluationRunEvaluationView = 'evaluation_run_evaluation_view',
	EvaluationAssessmentUpdate = 'evaluation_assessment_update',
	EvaluationAssessmentView = 'evaluation_assessment_view',
	UserListEvaluations = 'user_list_evaluations',
}
